/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_5_AInputs */

const en_vc_faq_5_a = /** @type {(inputs: Vc_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The project was called DrawCraft when it launched and was renamed VectorCraft in October 2026. It is the same ArtCraft vector editor.`)
};

const zh_vc_faq_5_a = /** @type {(inputs: Vc_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。项目刚发布时叫 DrawCraft，2026 年 10 月改名为 VectorCraft，是同一款 ArtCraft 矢量编辑器。`)
};

/**
* | output |
* | --- |
* | "Yes. The project was called DrawCraft when it launched and was renamed VectorCraft in October 2026. It is the same ArtCraft vector editor." |
*
* @param {Vc_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_5_a = /** @type {((inputs?: Vc_Faq_5_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_5_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_5_a(inputs)
	return zh_vc_faq_5_a(inputs)
});
export { vc_faq_5_a as "vc.faq.5.a" }